/**
 * @description
 * Objeto AmbitoRepresenta
 */

import { AdministracionRepresenta } from "./administracionrepresenta.model";
import { ListaCapacidadRepresenta } from "./listacapacidadrepresenta.model";


export class AmbitoRepresenta {
    public capacitatgeneral: boolean;
    public accescarpetaregtel: boolean;
    public listaCapacidadRepresenta: ListaCapacidadRepresenta = new ListaCapacidadRepresenta();
    public administracionRepresenta: AdministracionRepresenta = new AdministracionRepresenta();
    constructor() {}
}